(() => {
  if (window.__synergyFreeGiftPriceReady) return;
  window.__synergyFreeGiftPriceReady = true;

  const GIFT_PROP = '_synergy_free_gift';
  let timer = null;
  let inFlight = false;

  const money = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (_) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const isGift = (item) => String(item?.properties?.[GIFT_PROP]) === 'true';

  const priceMarkup = (was, now, kind, isFree) => `
    <div class="synergy-free-gift-price" data-synergy-free-gift-price="${kind}" aria-label="Regular price ${was}. ${isFree ? `Free gift price ${now}.` : `Current gift price ${now}.`}">
      <s class="synergy-free-gift-price__was" aria-hidden="true">${was}</s>
      <strong class="synergy-free-gift-price__now" aria-hidden="true">${now}</strong>
      ${isFree ? '<span class="synergy-free-gift-price__badge" aria-hidden="true">FREE</span>' : ''}
    </div>`;

  function decorateRow(row, item, currency) {
    if (!row || !item) return;
    row.classList.add('synergy-free-gift-line');

    const unitWas = money(item.original_price, currency);
    const unitNowCents = Number(item.final_price ?? item.original_price ?? 0);
    const unitNow = money(unitNowCents, currency);
    const details = row.querySelector('.cart-item__details');

    if (details) {
      const current = details.querySelector('[data-synergy-free-gift-price="unit"]');
      if (!current) {
        const source = details.querySelector(':scope > .cart-item__discounted-prices, :scope > .product-option');
        if (source) source.classList.add('synergy-free-gift-price-source');
        const name = details.querySelector('.cart-item__name');
        if (name) name.insertAdjacentHTML('afterend', priceMarkup(unitWas, unitNow, 'unit', unitNowCents === 0));
      }
    }

    const lineWas = money(item.original_line_price, currency);
    const lineNowCents = Number(item.final_line_price ?? item.original_line_price ?? 0);
    const lineNow = money(lineNowCents, currency);
    row.querySelectorAll('.cart-item__totals .cart-item__price-wrapper').forEach((wrapper) => {
      wrapper.querySelectorAll(':scope > *').forEach((child) => {
        if (!child.matches('[data-synergy-free-gift-price]')) {
          child.classList.add('synergy-free-gift-price-source');
        }
      });
      if (!wrapper.querySelector('[data-synergy-free-gift-price="line"]')) {
        wrapper.insertAdjacentHTML('beforeend', priceMarkup(lineWas, lineNow, 'line', lineNowCents === 0));
      }
    });
  }

  async function decorate() {
    if (inFlight || !document.getElementById('main-cart-items')) return;
    inFlight = true;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      const currency = cart.currency || 'USD';

      (cart.items || []).forEach((item, index) => {
        if (!isGift(item)) return;
        decorateRow(document.getElementById(`CartItem-${index + 1}`), item, currency);
      });
    } catch (error) {
      console.warn('Synergy free gift price display skipped', error);
    } finally {
      inFlight = false;
    }
  }

  function schedule(delay = 80) {
    clearTimeout(timer);
    timer = setTimeout(decorate, delay);
  }

  function init() {
    schedule(0);
    document.addEventListener('synergy:cart-rendered', () => schedule(40));

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule(220));
    }

    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) {
      const observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.type === 'childList' && mutation.addedNodes.length)) {
          schedule(120);
        }
      });
      observer.observe(cartItems, { childList: true, subtree: true });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();